export const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;
  let card = document.getElementById('cardAttention');

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen;
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen;
  const handleFullScreenChange = () => {
    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      // console.log('Exit fullscreen');
      card.classList.remove('fullscreen');
    } else {
      // console.log('Enter fullscreen');
      card.classList.add('fullscreen');
    }
  };

  doc.addEventListener('fullscreenchange', handleFullScreenChange);
  doc.addEventListener('mozfullscreenchange', handleFullScreenChange);
  doc.addEventListener('webkitfullscreenchange', handleFullScreenChange);
  doc.addEventListener('MSFullscreenChange', handleFullScreenChange);

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    // console.log('add fullscreen');
    card.classList.add('fullscreen');
    requestFullScreen.call(card);
  } else {
    if (card.classList.contains('fullscreen')) {
      // console.log('si existe');
      card.classList.remove('fullscreen');
    }
    // console.log('card', card.classList);
    cancelFullScreen.call(document);
  }
};
